<template>
  <x-page title="我的订单" :loading="loading">
    <div>
      <div class="wrapper">
        <div class="brief">
          <OrderSchedule :order="orderData" @finish="handleDelayReload" />
        </div>
        <div class="ssss">
          <OrderExpressAndConsignee :order="orderData" />
        </div>

        <OrderGoodsList :order="orderData" />

        <OrderInvoice :order="orderData" />

        <OrderExtraInfo :order="orderData" />

        <div :class="_.afterSalesDesc" @click="handleAfterSalesHelpClick">
          <div :class="_.title">售后服务说明</div>
          <!-- <van-icon name="question-o" :class="_.help" /> -->
          <van-icon name="arrow" :class="_.arrow" />
        </div>
      </div>

      <x-goods-recommend
        v-if="$globalModel.state.channelIsShowDcbResource"
        resource-position-id="8aaa8ac37b113694017b1144d350005d"
        :top="10"
      />

      <OrderActions :item="orderData" class="actions" @refresh="prepareData" />
      <div class="placeholder" />
    </div>
  </x-page>
</template>

<script>
  import OrderActions from './components/order_actions'
  import OrderExpressAndConsignee from './components/order_express_and_consignee'
  import OrderExtraInfo from './components/order_extra_info'
  import OrderGoodsList from './components/order_goods_list'
  import OrderInvoice from './components/order_invoice'
  import OrderSchedule from './components/order_schedule'
  import Vue from 'vue'
  import { apiOrderOrderDetail } from '@/api'
  import { dcb } from '@dcb/jssdk'
  import { mapQuery, prepareData, Track } from '@/utils'
  import { navigateBack } from '@/router'
  import { wait } from 'vtils'

  export default Vue.extend({
    noKeepalive: true,

    components: {
      OrderExtraInfo,
      OrderInvoice,
      OrderExpressAndConsignee,
      OrderSchedule,
      OrderActions,
      OrderGoodsList,
    },

    mixins: [
      mapQuery({
        // 订单号
        orderNo: [
          'orderNo',
          // 兼容老版路由
          'no',
        ],
      }),
      Track.provideMark(() => ({
        page: '订单详情',
      })),
    ],

    data() {
      return {
        // 页面加载状态
        loading: true,

        // 订单数据
        orderData: {},
      }
    },

    activated() {
      this.prepareData()
    },

    methods: {
      // 准备数据
      async prepareData({ trigger } = {}) {
        if (trigger === 'delete') {
          navigateBack()
        } else {
          const { orderData } = await prepareData({
            orderData: apiOrderOrderDetail({
              orderNo: this.orderNo,
            }),
          })
          this.orderData = orderData
          this.loading = false
        }
      },

      // 延时重载
      async handleDelayReload() {
        this.loading = true
        await wait(5000)
        await this.prepareData()
      },

      // 点击联系客服
      handleContactClick() {
        dcb.makeCustomerServicePhoneCall()
      },

      // 点击售后说明
      handleAfterSalesHelpClick() {
        dcb.navigateTo({
          url: 'https://wap.gogpay.cn/8aaa86d67aebce0f017bcedb50170027',
        })
      },
    },
  })
</script>

<style lang="scss" scoped>
  .wrapper {
    padding: 12px;

    .brief {
      position: relative;

      &::after {
        content: '';
        position: absolute;
        top: -12px;
        left: -12px;
        right: -12px;
        bottom: 0;
        z-index: -1;
        background: linear-gradient(180deg, #ff273c 0%, #ff111c 100%);
        clip-path: polygon(
          50% 0%,
          100% 0,
          100% 35%,
          100% 70%,
          85% 91%,
          49% 100%,
          17% 92%,
          0% 70%,
          0% 35%,
          0 0
        );
      }
    }

    .contact {
      width: 100%;
      background: #ffffff;
      border-radius: 8px;
      margin-top: 10px;
      padding: 12px;
      font-size: 14px;
      color: #1d1d1c;
      display: flex;
      align-items: center;
      justify-content: center;
      border: none;

      .icon {
        width: 20px;
        height: 20px;
        margin-right: 6px;
      }

      &:active {
        opacity: 0.8;
      }
    }
  }

  .actions {
    position: fixed;
    // fix: iPhone 8 下不随滑动实时更新问题
    transform: translate3d(0, 0, 0);
    bottom: 0;
    right: 0;
    left: 0;
    background-color: white;
    text-align: right;
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    box-sizing: content-box;
    padding: 0 12px;
    padding-bottom: constant(safe-area-inset-bottom);
    padding-bottom: env(safe-area-inset-bottom);

    + .placeholder {
      height: 50px;
    }
  }
</style>

<style lang="scss" module>
  .afterSalesDesc {
    margin-top: 12px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 12px;
    background: white;
    border-radius: 8px;

    .title {
      flex-shrink: 0;
      font-size: 14px;
      color: #222222;
    }

    .arrow {
      font-size: 12px;
      color: #bebebe;
    }

    &:active {
      opacity: 0.8;
    }
  }
</style>
